import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import RouterPropTypes from 'react-router-prop-types';

import { modelOf } from '../../../prop-types';
import Product from '../../../models/Product';
import ProductClass from '../../../types/ProductClass';
import { addParametersToPath } from '../../../util/queryString';
import ProductPropertyType from '../../../types/ProductPropertyType';
import ProductCardPropertySelect from '../ProductCardPropertySelect';
import RouteService from '../../../services/RouteService';

@observer
export class ProductCardProperties extends Component {
  getFirstCollectionProperty = (product) => {
    return product.collection.shouldSwapCollectionOrder()
      ? product.collection.row
      : product.collection.column;
  };

  getSecondCollectionProperty = (product) => {
    return product.collection.shouldSwapCollectionOrder()
      ? product.collection.column
      : product.collection.row;
  };

  getElementIds = (elementId, isFirstCollection) => {
    const { product, selectedElementId } = this.props;

    const elementIds = {
      columnId: null,
      rowId: null
    };

    // Check if collections are swapped
    let firstProperty = 'columnId';
    let secondProperty = 'rowId';
    if (product.collection.shouldSwapCollectionOrder()) {
      firstProperty = 'rowId';
      secondProperty = 'columnId';
    }

    if (isFirstCollection) {
      elementIds[firstProperty] = elementId;
    } else {
      elementIds[firstProperty] = selectedElementId;
      elementIds[secondProperty] = elementId;
    }

    // If a property is empty, we know that the element ID is 0.
    if (product.collection.column.isEmpty()) {
      elementIds.columnId = 0;
    }
    if (product.collection.row.isEmpty()) {
      elementIds.rowId = 0;
    }

    return elementIds;
  };

  onCollectionPropertyElementClick = (
    propertyId,
    elementId,
    isFirstCollectionClicked
  ) => {
    const { history, product, routeService } = this.props;
    const elementIds = this.getElementIds(elementId, isFirstCollectionClicked);

    // If we know both element IDs, link directly to active product
    let path;
    if (elementIds.columnId !== null && elementIds.rowId !== null) {
      const item = product.collection.getItem(
        elementIds.columnId,
        elementIds.rowId
      );
      path = product.pathWithActiveProductId(item.product.id);
    } else {
      path = addParametersToPath(product.path, elementIds);
    }
    history.push(routeService.getProductPath(product, path));
  };

  onCollectionElementHover = (elementId, isFirstCollection) => {
    const { onFirstCollectionElementHovered } = this.props;
    if (isFirstCollection) {
      onFirstCollectionElementHovered(elementId);
    }
  };

  isElementAvailable = (elementId, isFirstProperty) => {
    const { product } = this.props;

    const { columnId, rowId } = this.getElementIds(elementId, isFirstProperty);
    let status;
    if (columnId !== null && rowId !== null) {
      status = product.collection.getItemStatus(columnId, rowId);
    } else if (columnId !== null) {
      status = product.collection.getColumnStatus(columnId);
    } else {
      status = product.collection.getRowStatus(rowId);
    }
    return status.available;
  };

  componentForCollectionProperty = (collectionProperty, isFirstProperty) => {
    const { product, filterNotInStockElements } = this.props;

    if (collectionProperty.isEmpty()) {
      return null;
    }

    const { selectedElementId } = this.props;
    const clickHandler = (propertyId, elementId) =>
      this.onCollectionPropertyElementClick(
        propertyId,
        elementId,
        isFirstProperty
      );
    const hoverHandler = (propertyId, elementId) =>
      this.onCollectionElementHover(elementId, isFirstProperty);
    const elements =
      filterNotInStockElements && !product.canBeOrderedOutOfStock
        ? collectionProperty.elements.filter((element) =>
            this.isElementAvailable(element.id, isFirstProperty)
          )
        : collectionProperty.elements;

    if (elements.length === 0) {
      return null;
    }

    let selectedElementIdForComponent = null;
    if (isFirstProperty) {
      selectedElementIdForComponent = selectedElementId || elements[0].id;
    }

    return (
      <ProductCardPropertySelect
        product={product}
        propertyId={collectionProperty.id}
        elements={elements}
        onElementClick={clickHandler}
        onElementHover={hoverHandler}
        selectedElementId={selectedElementIdForComponent}
        asThumbnails={collectionProperty.type === ProductPropertyType.COLOR}
      />
    );
  };

  render() {
    const { product } = this.props;
    if (product.class !== ProductClass.COLLECTION) {
      return null;
    }

    return (
      <div className="ProductCardProperties">
        {this.componentForCollectionProperty(
          this.getFirstCollectionProperty(product),
          true
        )}
        {this.componentForCollectionProperty(
          this.getSecondCollectionProperty(product),
          false
        )}
      </div>
    );
  }
}

ProductCardProperties.propTypes = {
  filterNotInStockElements: PropTypes.bool,
  product: modelOf(Product).isRequired,
  history: RouterPropTypes.history.isRequired,
  routeService: PropTypes.instanceOf(RouteService).isRequired,
  onFirstCollectionElementHovered: PropTypes.func.isRequired,
  selectedElementId: PropTypes.number
};

export default withRouter(
  inject(({ configStore, routeService }) => ({
    filterNotInStockElements: configStore.inStockProductsOnly,
    routeService
  }))(ProductCardProperties)
);



// WEBPACK FOOTER //
// ./src/components/product/ProductCardProperties/index.jsx